import Trailer from './Trailer';
import TrailerDialog from './TrailerDialog';
import TrailerForm from './TrailerForm';
import TrailerList from './TrailerList';

export { Trailer, TrailerDialog, TrailerForm, TrailerList };

export default Trailer;
